import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retry, mergeMap, timeout } from 'rxjs/operators';
import { Logger } from '../logger.service';

export const retryCount = 5;
export const retryWaitMilliSeconds = 1000;
export const codesForRetry = [0, 501, 502, 503, 504, 505];
const log = new Logger('MonitorInterceptor');

@Injectable()
export class MonitorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipRetry = request.headers.has('hideMonitor');
    let timeoutInterval = Number(request.headers.get('timeout'));
    if (skipRetry) {
      return next.handle(request);
    }
    if (!timeoutInterval) {
      timeoutInterval = 60000; // Default to 20 seconds if not specified
    }

    return next.handle(request).pipe(
      timeout(timeoutInterval), // 30 seconds timeout
      retry({
        count: retryCount,
        delay: (error, retryIndex) => {
          const isRetryable = error.name === 'TimeoutError' || codesForRetry.includes(error.status ?? 0);

          if (!isRetryable) {
            throw error;
          }
          log.debug(`Retrying [${retryIndex + 1}] due to:`, error);
          return timer(retryWaitMilliSeconds * (retryIndex + 1));
        },
      })
    );
  }
}
